
import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";

import AllTickets from "../../components/organization/reports/AllTickets";
import { getReportDescription } from "../../store/helpers";

import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  TICKET_SUMMARY_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const TicketsPage = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);

  const { data } = reportsData;

  const reportTitle = `${reportIndex}. Organization Tickets`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: TICKET_SUMMARY_COLUMN_DEFINITIONS,
  });

  console.log(data);
  

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p>{getReportDescription(reportRange).Tickets}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        <AllTickets reportIndex={reportIndex} data={data[0]} renderConfig={renderConfig} />
      ) : <Box mt={10}>
              <p>No data available in this report</p>
            </Box>}
    </Box>
  );
};

export default TicketsPage;
